export const colors = {
};
  
export const fonts = {
};

export const mediaQueries = {
  mobile: "@media only screen and (max-width: 768px)",
  notMobile: "@media screen and (min-width: 701px)",
  notTablet: "@media screen and (min-width: 901px)",
  tablet: "@media screen and (max-width: 900px)"
};
  
